import {
  Divider,
  Grid,
  IconButton,
  AppBar,
  Tabs,
  Tab,
  makeStyles,
  Menu,
  MenuItem,
  ListItemIcon
} from "@material-ui/core";
import AccountIcon from "@material-ui/icons/AccountCircle";
import AppsIcon from "@material-ui/icons/Apps";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import LoginDialog from "./LoginDialog";
import { PageLabel, PagePath } from "../types";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  offset: theme.mixins.toolbar,
  logo: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  }
}));

const pages = [
  { label: PageLabel.Index, to: PagePath.Index },
  { label: PageLabel.About, to: PagePath.About },
  { label: PageLabel.Repair, to: PagePath.Repair },
  { label: PageLabel.Check, to: PagePath.Check },
  { label: PageLabel.Wechat, to: PagePath.Wechat },
  { label: PageLabel.Lanke, to: PagePath.Lanke },
  { label: PageLabel.Suggest, to: PagePath.Suggest },
  { label: PageLabel.Complain, to: PagePath.Complain }
];

export default function NavBar() {
  const classes = useStyles();
  const { pathname } = useLocation();
  const [currentPage, setCurrentPage] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);

  useEffect(() => {
    // 导航栏匹配一级路由
    /*
      /about      -> /about
      /about/     -> /about
      /about/123  -> /about
    */
    let firstLevelPath = pathname;
    const slashIndex = firstLevelPath.indexOf("/", 1);
    if (slashIndex !== -1) {
      firstLevelPath = firstLevelPath.slice(0, slashIndex);
    }

    const indexMatch = pages.findIndex(page => firstLevelPath === page.to);
    setCurrentPage(indexMatch);
  }, [pathname]);

  if (pathname.includes("admin")) {
    return null;
  }

  const handleOpenUserMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorEl(null);
  };

  function AccountMenu() {
    return (
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={Boolean(anchorEl)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem onClick={handleCloseUserMenu} component={Link} to="/admin">
          <ListItemIcon>
            <AppsIcon />
          </ListItemIcon>
          后台
        </MenuItem>
        <LoginDialog />
      </Menu>
    );
  }

  return (
    <div className={classes.root}>
      <AppBar position="fixed" color="primary">
        <Grid container>
          <Grid item xs={1} className={classes.logo}>
            <img
              src={`${process.env.PUBLIC_URL}/images/Logo_small_3.png`}
              alt="logo"
              height={40}
              style={{ position: "relative", top: 8, left: 4 }}
            />
          </Grid>
          <Grid item xs={10}>
            <Tabs
              value={currentPage}
              indicatorColor="secondary"
              textColor="inherit"
              variant="scrollable"
              scrollButtons="auto"
            >
              {pages.map((page, index) => (
                <Tab
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  label={page.label}
                  component={Link}
                  to={page.to}
                />
              ))}
            </Tabs>
          </Grid>
          <Grid item sm={1} xs={2}>
            <Divider orientation="vertical" style={{ position: "absolute" }} />
            <div style={{ textAlign: "center" }}>
              <IconButton onClick={handleOpenUserMenu}>
                <AccountIcon />
              </IconButton>
            </div>
            <AccountMenu />
          </Grid>
        </Grid>
      </AppBar>
      <div className={classes.offset} />
    </div>
  );
}
